import { DonationReportOutput } from 'gql/types';
import { TFunction } from 'i18next';
import { ReportColumnConfig } from 'modules/reports/types';
import { formatDateSafe } from 'modules/reports/utils/formatDateSafe';
import { formatSafeValue } from 'modules/reports/utils/formatSafeValue';

export const getDonationReportColumns = (
  t: TFunction
): ReportColumnConfig<DonationReportOutput>[] => [
  // --- Basic Info ---
  {
    key: 'id',
    label: t('id'),
    getValue: (item) => item.id || '',
  },
  {
    key: 'shortId',
    label: t('shortId'),
    getValue: (item) => item.shortId || '',
  },

  // --- Vitals ---
  {
    key: 'temperature',
    label: t('temperature'),
    getValue: (item) => formatSafeValue(item.temperature, ''),
  },
  {
    key: 'pulse',
    label: t('pulse'),
    getValue: (item) => formatSafeValue(item.pulse, ''),
  },
  {
    key: 'respiration',
    label: t('respiration'),
    getValue: (item) => formatSafeValue(item.respiration, ''),
  },
  {
    key: 'capillaryRefillTime',
    label: t('capillaryRefillTime'),
    getValue: (item) => formatSafeValue(item.capillaryRefillTime, ''),
  },
  {
    key: 'mucousMembrane',
    label: t('mucousMembrane'),
    getValue: (item) => item.mucousMembrane || '',
  },

  // --- Lab Values ---
  {
    key: 'packedCellVolume',
    label: t('packedCellVolume'),
    getValue: (item) => formatSafeValue(item.packedCellVolume, ''),
  },
  {
    key: 'totalSolids',
    label: t('totalSolids'),
    getValue: (item) => formatSafeValue(item.totalSolids, ''),
  },
  {
    key: 'weight',
    label: t('weight'),
    getValue: (item) => formatSafeValue(item.weight, ''),
  },

  // --- Donation Details ---
  {
    key: 'working',
    label: t('working'),
    getValue: (item) => formatSafeValue(item.working, ''),
  },
  {
    key: 'unit',
    label: t('unit'),
    getValue: (item) => formatSafeValue(item.unit, ''),
  },
  {
    key: 'actual',
    label: t('actual'),
    getValue: (item) => formatSafeValue(item.actual, ''),
  },
  {
    key: 'failedReason',
    label: t('failedReason'),
    getValue: (item) => formatSafeValue(item.failedReason, ''),
  },
  {
    key: 'approvedDonationsMl',
    label: t('approvedDonationsMl'),
    getValue: (item) => formatSafeValue(item.approvedDonationsMl, ''),
  },
  {
    key: 'donationDate',
    label: t('donationDate'),
    getValue: (item) => formatDateSafe(item.donationDate),
  },
  {
    key: 'donationNumber',
    label: t('donationNumber'),
    getValue: (item) => formatSafeValue(item.donationNumber, ''),
  },
  {
    key: 'jugularVein',
    label: t('jugularVein'),
    getValue: (item) => item.jugularVein || '',
  },
  {
    key: 'ineligibleReason',
    label: t('ineligibleReason'),
    getValue: (item) => item.ineligibleReason || '',
  },

  // --- Additional Info ---
  {
    key: 'additionalInfoId',
    label: t('additionalInfoId'),
    getValue: (item) => item.additionalInfo?.id || '',
  },
  {
    key: 'numberOfCollectionUnitsUsed',
    label: t('numberOfCollectionUnitsUsed'),
    getValue: (item) =>
      formatSafeValue(item.additionalInfo?.numberOfCollectionUnitsUsed, ''),
  },

  // --- Primary Holder ---
  {
    key: 'primaryHolderFirstName',
    label: t('primaryHolderFirstName'),
    getValue: (item) => item.additionalInfo?.primaryHolder?.firstName || '',
  },
  {
    key: 'primaryHolderLastName',
    label: t('primaryHolderLastName'),
    getValue: (item) => item.additionalInfo?.primaryHolder?.lastName || '',
  },

  // --- Poker ---
  {
    key: 'pokerFirstName',
    label: t('pokerFirstName'),
    getValue: (item) => item.additionalInfo?.poker?.firstName || '',
  },
  {
    key: 'pokerLastName',
    label: t('pokerLastName'),
    getValue: (item) => item.additionalInfo?.poker?.lastName || '',
  },

  // --- Donor Info ---
  {
    key: 'donorId',
    label: t('donorId'),
    getValue: (item) => item.donor?.id || '',
  },
  {
    key: 'donorFirstName',
    label: t('donorFirstName'),
    getValue: (item) => item.donor?.name || '',
  },
  {
    key: 'donorLastName',
    label: t('donorLastName'),
    getValue: (item) => item.donor?.user?.lastName || '',
  },
  {
    key: 'donorLocation',
    label: t('donorLocation'),
    getValue: (item) => item.donor?.location || '',
  },
  {
    key: 'donorRegion',
    label: t('donorRegion'),
    getValue: (item) => item.donor?.region || '',
  },

  // --- Comment ---
  {
    key: 'comment',
    label: t('comment'),
    getValue: (item) => item.comment || '',
  },
];
